import { render, staticRenderFns } from "./WeekPlanTabComponent.vue?vue&type=template&id=ffdb8cce&"
import script from "./WeekPlanTabComponent.vue?vue&type=script&lang=js&"
export * from "./WeekPlanTabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports